import dayjs from "dayjs";

import style from "@styles/pages/flow/FlowCard.module.scss";

import { FlowAPI } from "@providers/FlowAPI";
import classNames from "classnames/bind";

import { useState } from "react";
const css = classNames.bind(style);

export const FlowCard = ({ flow, onClick, onLoadFlows }) => {
  const getCampaignStatus = (value) => {
    const status = {
      ACTIVE: "success",
      FINISHED: "success",
      UNDER_ANALYSIS: "neutral",
      DRAFT: "neutral",
      EXPIRED_DRAFT: "danger",
      ARCHIVED: "neutral",
      SCHEDULED: "neutral",
      PROCESSING: "neutral",
      PAUSED: "paused",
      PUBLISHED: "success",
    };

    return status[value] || "exclamation";
  };

  const getCampaignStatusName = (value) => {
    const status = {
      ACTIVE: "Ativa",
      FINISHED: "Encerrada",
      UNDER_ANALYSIS: "Em análise",
      DRAFT: "Rascunho",
      EXPIRED_DRAFT: "Rascunho expirado",
      ARCHIVED: "Arquivado",
      SCHEDULED: "Enviando",
      PROCESSING: "Enviando",
      PAUSED: "Pausada",
      PUBLISHED: flow?.rank_bypass ? "Publicado com prioridade" : "Publicado",
    };

    return status[value] || "Erro";
  };

  const [collapsed, setCollapsed] = useState(false);

  const archive = async () => {
    const saveResponse = await FlowAPI.putArchiveFlow(flow.id);
    if (saveResponse.getErrors([]).length > 0) {
      alert({
        text: saveResponse.getErrors(["Ocorreu um erro ao arquivar"])[0],
        buttonText: "Voltar",
      });
    } else onLoadFlows();
  };

  return (
    <div className={style["flow-box"]} onClick={() => onClick && onClick(flow)}>
      <div className={style.header}>
        <div className="d-flex justify-between">
          <div className="d-flex align-center">
            <div className={style.icon}>
              <i className="far fa-arrows-split-up-and-left" />
            </div>
            <div className="d-flex flex-column">
              <p className={style.name}>{flow.name}</p>
              <div className={style.updatedAt}>
                <p>
                  Última alteração em:{" "}
                  <span>{dayjs(flow.updated_at).format("DD/MM/YYYY")}</span> às{" "}
                  <span>{dayjs(flow.updated_at).format("HH:mm")}</span>
                </p>
              </div>
            </div>
          </div>

          {flow.state !== "ARCHIVED" && (
            <div className="d-flex align-center">
              <div className={style.status}>
                <p className={css({ [getCampaignStatus(flow.state)]: true })}>
                  {getCampaignStatusName(flow.state)}
                </p>
              </div>
              <div
                className={style.chevron}
                onClick={(e) => {
                  e.stopPropagation();
                  setCollapsed(!collapsed);
                }}
              >
                <i className="fal fa-ellipsis-v" />

                <div
                  className={css({
                    actions: true,
                    in: collapsed,
                    out: !collapsed,
                  })}
                >
                  <ul className={style.options}>
                    {/* <li onClick={() => {}}>Duplicar fluxo</li> */}
                    <li onClick={archive}>Arquivar fluxo</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className={style.hasChanges}>
          {flow.has_changes ? (
            <p className={style.tag}>Há alterações não publicadas</p>
          ) : null}
          <p className={style.tag}>Antiga versão de público em uso</p>
        </div>
      </div>
    </div>
  );
};
